import DeleteIcon from "@mui/icons-material/Delete";
import {
    Button,
    Checkbox,
    FormControlLabel,
    FormGroup,
    IconButton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";
import { FieldArray, Form, FormikProvider, useFormik } from "formik";
import * as yup from "yup";

const validationSchema = yup.object({
    reportResults: yup.array().of(
        yup.object({
            timeframeYear: yup.number().required(),
            resultValue: yup.number(),
            // yup.number().when(["noResult"], {
            //     is: (noResult) => Boolean(noResult),
            //     then: yup.number(),
            //     otherwise: yup.number().required(),
            // }),
            noResult: yup.boolean().required(),
        })
    ),
});

// type props: arrayHelpers
function FieldArrayExpectedResult(props) {
    const { form, name: fieldArrayName, push, remove } = props;
    const { value, error, touched } = form.getFieldMeta(fieldArrayName);
    const defaultValue = {
        timeframeYear: "",
        resultValue: "",
        noResult: false,
    };
    const getFieldNameIndex = (name, index) => `${fieldArrayName}[${index}].${name}`;
    const handleAdd = () => push(defaultValue);
    const handleRemove = (index) => remove(index);
    const columnCount = 4;

    return (
        <>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell component="th">ปี</TableCell>
                        <TableCell component="th">ผล</TableCell>
                        <TableCell component="th"></TableCell>
                        <TableCell component="th"></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {value && value.length > 0 ? (
                        value.map((_, index) => (
                            <TableRow key={index}>
                                <TableCell>
                                    <TextField
                                        type="number"
                                        name={getFieldNameIndex("timeframeYear", index)}
                                        label="ปี"
                                        value={value[index].timeframeYear}
                                        fullWidth
                                        onChange={form.handleChange}
                                        onBlur={form.handleBlur}
                                        error={error && Boolean(error[index]?.timeframeYear)}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        type="number"
                                        name={getFieldNameIndex("resultValue", index)}
                                        label="ผลดำเนินงาน"
                                        value={value[index].resultValue}
                                        fullWidth
                                        onChange={form.handleChange}
                                        onBlur={form.handleBlur}
                                        error={error && Boolean(error[index]?.resultValue)}
                                        disabled={value[index].noResult}
                                    />
                                </TableCell>
                                <TableCell>
                                    <FormGroup>
                                        <FormControlLabel
                                            label="ไม่มีข้อมูล"
                                            control={
                                                <Checkbox
                                                    name={getFieldNameIndex("noResult", index)}
                                                    checked={Boolean(value[index].noResult)}
                                                    onChange={form.handleChange}
                                                    onBlur={form.handleBlur}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </TableCell>
                                <TableCell>
                                    <IconButton onClick={() => handleRemove(index)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={columnCount}>ไม่มีข้อมูล</TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>

            <Button onClick={handleAdd} sx={{ margin: 1 }}>
                เพิ่มผลดำเนินงาน
            </Button>
        </>
    );
}

export default function KpiEditResultForm(props) {
    const { title, initialValues, onSubmit, onReset, onClose, ...restProps } = props;

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: async (values, { setSubmitting }) => {
            setSubmitting(true);
            try {
                if (onSubmit instanceof Function) {
                    await onSubmit(values);
                }
            } catch (error) {}

            setSubmitting(false);
        },
    });

    return (
        <FormikProvider value={formik}>
            <Form>
                <Typography gutterBottom>{title}</Typography>

                <FieldArray name="reportResults" component={FieldArrayExpectedResult} />

                <Stack direction="row" spacing={1} sx={{ marginTop: 3 }}>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={formik.isSubmitting || !formik.dirty}
                    >
                        บันทึก
                    </Button>
                    <Button type="reset" disabled={formik.isSubmitting} onClick={onClose}>
                        ยกเลิก
                    </Button>
                </Stack>
            </Form>
        </FormikProvider>
    );
}
